import * as React from "react";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { useEffect } from "react";
import NeedsByServiceTypeTableRow from "./NeedsByServiceTypeTableRow";
import { useNeedsByServiceTypeData } from "../../hooks/useNeedsByServiceTypeData";

export default function NeedsByServiceTypeTableReport({
  title,
  group,
  city,
  state,
  cityObj,
  openAll,
  search,
  causeAndActionReportData,
}) {
  const [open, setOpen] = React.useState(false);
  const [lines, setLines] = React.useState([]);

  const { processGroupData, createNavigationHandlers } =
    useNeedsByServiceTypeData(group, search, causeAndActionReportData);

  const { handleAdd, handleView, handleEdit } = createNavigationHandlers(
    city,
    state,
    cityObj
  );

  useEffect(() => {
    const result = processGroupData();
    if (result) {
      setLines(result);
    }
  }, [processGroupData]);

  useEffect(() => {
    setOpen(openAll);
  }, [openAll]);

  return (
    <div>
      <div
        className={
          `flex flex-row justify-between items-center px-4 py-3 bg-white border border-gray-200` +
          (open ? " rounded-t-lg" : " rounded-lg")
        }
        style={{ overflowX: "auto", flexWrap: "wrap", gap: "1rem" }}
      >
        <div className="flex items-center">
          <IconButton
            size="small"
            onClick={() => setOpen(!open)}
            sx={{
              color: "#6b7280",
              backgroundColor: "transparent",
              border: "1px solid #e5e7eb",
              borderRadius: "4px",
              marginRight: "12px",
              p: 0.5,
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            {open ? <Remove fontSize="small" /> : <Add fontSize="small" />}
          </IconButton>
          <span className="font-medium text-gray-700 text-sm">
            {title}
            {lines.length > 0 && (
              <span className="ml-2 text-xs text-gray-500 font-normal">
                ({lines.length}{" "}
                {lines.length === 1 ? "parâmetro" : "parâmetros"})
              </span>
            )}
          </span>
        </div>
      </div>

      <TableContainer
        component={Paper}
        square
        elevation={0}
        sx={{
          overflowX: "auto",
          border: "1px solid #e5e7eb",
          borderTop: open ? "none" : "1px solid #e5e7eb",
          borderRadius: open ? "0 0 8px 8px" : "8px",
        }}
      >
        <Table sx={{ border: "none" }}>
          {open && lines.length > 0 && (
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#fdfdfd",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",

                    },
                    color: "#374151",
                    py: {
                      xs: 1,
                      sm: 1.5
                    },
                  }}
                >
                  Código
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",

                    },
                    color: "#374151",
                    py: {
                      xs: 1,
                      sm: 1.5
                    },
                  }}
                >
                  Tipo Prestador
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",

                    },
                    color: "#374151",
                    py: {
                      xs: 1,
                      sm: 1.5
                    },
                  }}
                >
                  {title}
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",

                    },
                    color: "#374151",
                    py: {
                      xs: 1,
                      sm: 1.5
                    },
                  }}
                >
                  Necessidade Serviço
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",

                    },
                    color: "#374151",
                    py: {
                      xs: 1,
                      sm: 1.5
                    },
                  }}
                >
                  Nº Serviço s/ Fator
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",

                    },
                    color: "#374151",
                    py: {
                      xs: 1,
                      sm: 1.5
                    },
                  }}
                >
                  Fator de Ajuste
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",

                    },
                    color: "#374151",
                    py: {
                      xs: 1,
                      sm: 1.5
                    },
                  }}
                >
                  Nº Serviço + Fator
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",

                    },
                    color: "#374151",
                    py: {
                      xs: 1,
                      sm: 1.5
                    },
                  }}
                >
                  Diferença
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",

                    },
                    color: "#374151",
                    py: {
                      xs: 1,
                      sm: 1.5
                    },
                  }}
                >
                  Suficiência de Rede
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",

                    },
                    color: "#374151",
                    py: {
                      xs: 1,
                      sm: 1.5
                    },
                  }}
                >
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {open &&
              lines.map((row) => (
                <NeedsByServiceTypeTableRow
                  key={row.className}
                  row={row}
                  title={title}
                  stateOpen={openAll}
                  clickEventAdd={handleAdd}
                  clickEventEdit={handleEdit}
                  clickEventView={handleView}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
